import getConfig from "next/config";
import fetcher from "src/utils/fetcher";
const { googleMapsApiKey, searchBase } = getConfig().publicRuntimeConfig;

export const defaultPolygon = [
	{ lng: -56.2110273, lat: -34.874495 },
	{ lng: -56.2182371, lat: -34.8932235 },
	{ lng: -56.2287084, lat: -34.9030789 },
	{ lng: -56.222357, lat: -34.9150446 },
	{ lng: -56.2036459, lat: -34.9144816 },
	{ lng: -56.1778967, lat: -34.9219417 },
	{ lng: -56.1584989, lat: -34.9351712 },
	{ lng: -56.1174719, lat: -34.9098362 },
	{ lng: -56.1217634, lat: -34.8997 },
	{ lng: -56.1626188, lat: -34.8680164 },
	{ lng: -56.1677686, lat: -34.8699882 },
	{ lng: -56.2022726, lat: -34.8722416 },
	{ lng: -56.2110273, lat: -34.874495 },
];

const centers = {
	UY: { lat: -34.9030204, lng: -56.1494 },
	PY: { lat: -25.2637, lng: -57.5759 },
	PE: { lat: -12.0464, lng: -77.0428 },
	BO: { lat: -16.5, lng: -68.15 },
	CO: { lat: 4.7110, lng: -74.0721 },
};

const countryBoundaries = {
	CO: [
		// Zona continental
		{ minLat: 1.0,   maxLat: 12.0,  minLng: -79.0, maxLng: -66.0 },
		// San Andrés
		{ minLat: 12.5,  maxLat: 13.0,  minLng: -82.0, maxLng: -81.3 },
		// Providencia y Santa Catalina
		{ minLat: 13.3,  maxLat: 13.5,  minLng: -81.4, maxLng: -81.3 },
		// Islas del Rosario y San Bernardo
		{ minLat: 9.3,   maxLat: 10.0,  minLng: -75.9, maxLng: -75.5 }
	],
	PE: [
		// Zona continental
		{ minLat: -18.35, maxLat: -0.01, minLng: -81.3, maxLng: -68.7 },
		// Isla San Lorenzo (frente a Callao)
		{ minLat: -12.1,  maxLat: -12.05, minLng: -77.2, maxLng: -77.1 },
		// Islas Lobos de Afuera
		{ minLat: -6.9,   maxLat: -6.8,   minLng: -80.8, maxLng: -80.7 },
		// Islas Chincha y Ballestas
		{ minLat: -13.8,  maxLat: -13.6,  minLng: -76.4, maxLng: -76.1 }
	],
	PY: [
		// Solo zona continental, no posee islas oceánicas o alejadas
		{ minLat: -27.6,  maxLat: -19.3, minLng: -62.0, maxLng: -54.0 }
	],
	UY: [
		// Zona continental
		{ minLat: -35.0,  maxLat: -30.0, minLng: -58.5, maxLng: -53.0 },
		// Isla de Lobos
		{ minLat: -35.02, maxLat: -34.98, minLng: -54.55, maxLng: -54.50 }
	],
	BO: [
		// Zona continental
		{ minLat: -22.9,  maxLat: -9.0,  minLng: -69.6, maxLng: -57.5 }
	]
};


export const mapSettings = country_code => {
	return {
		googleMapsApiKey: googleMapsApiKey,
		dafaults: {
			center: centers[country_code],
			zoom: 14,
		},
		options: {
			fullscreenControl: false,
			//@todo: minZoom deberieria ser mayor a 0, pero como todavia hay puntos que aparecen en el mar, necesitas el zoom 0 para poder hacer el map fitBound
			minZoom: 8,
			maxZoom: 18,
			gestureHandling: "greedy",
		},
	};
};

export const extendedBounds = b => {
	if (!b) return null;
	const marginSize = 0.1; // as a % of map size
	let n = b.ne.lat;
	let s = b.se.lat;
	let e = b.ne.lng;
	let w = b.nw.lng;

	let latMargin = (n - s) * marginSize;
	let longMargin = (e - w) * marginSize;

	n = n + latMargin;
	s = s - latMargin;
	e = e + longMargin;
	w = w - longMargin;

	return { n, s, e, w };
};

export const filterPointsOutOfMap = (p, extBounds) =>
	p?.filter(item => {
		let lat = parseFloat(item.lat);
		let long = parseFloat(item.long);
		return lat < extBounds.n && lat > extBounds.s && long < extBounds.e && long > extBounds.w;
	});

export const pointArrayLongFormat = pointArr => {
	if (!pointArr) return null
	return pointArr?.map(point => {
		if (Array.isArray(point)) {
			return point.map(p => ({latitude: p.lat, longitude: p.lng}))
		} else return { latitude: point.lat, longitude: point.lng };
	});
}

export const fetchMapPoints = async (filters = null, polygonsData, main_domain) => {
	let map_polygons = !!polygonsData.polygon.length ?
		Array.isArray(polygonsData.polygon[0]) ? polygonsData.polygon :
		[polygonsData.polygon]
	: null;

	const url = `${searchBase}/api/v1/properties/map-search`;
	// const url = "https://bgraph.infocasas.com.uy/api/map-search-test"; //@todo: deshardcodear esto

	let body = filters
		? filters
		: {
			operation_type_id: 1,
			order: 2,
			page: 1,
		};

	body = {
		...body, 
		first: 10000, 
		map_polygons: pointArrayLongFormat(map_polygons),
		locations: polygonsData.polygonsWithourCoordinates
	};

	body = JSON.stringify(body);

	try {
		const request = fetcher(url, {
			method: 'POST',
			body: body,
			headers: {
				"x-origin": main_domain,
				"Content-Type": "application/json",
			},
		})
			.then(data => {
				const filteredPoints = data.filter((p) => (p.lat !== "0" || p.long !== "0"))
				return filteredPoints
			})
			.catch(error => console.error("fetchMapPoints failed", error));

		return request;
	} catch (error) {
		if (error.name !== "AbortError") {
			throw error;
		}
	}
};

export const filterPointsByCountry = (countryCode, points) => {
	const areas = countryBoundaries[countryCode.toUpperCase()];
	if (!areas) {
		throw new Error("Código de país inválido");
	}

	return points.filter(point => {
		return areas.some(area =>
			point.lat >= area.minLat &&
			point.lat <= area.maxLat &&
			point.long >= area.minLng &&
			point.long <= area.maxLng
		);
	});
};

/* Stack-based Douglas Peucker line simplification routine 
   returned is a reduced GLatLng array 
   After code by  Dr. Gary J. Robinson,
   Environmental Systems Science Centre,
   University of Reading, Reading, UK
*/

export const GDouglasPeucker = (source, kink) => {
	var n_source, n_stack, n_dest, start, end, i, sig;
	var dev_sqr, max_dev_sqr, band_sqr;
	var x12, y12, d12, x13, y13, d13, x23, y23, d23;
	var F = (Math.PI / 180.0) * 0.5;
	var index = new Array(); /* aray of indexes of source points to include in the reduced line */
	var sig_start = new Array(); /* indices of start & end of working section */
	var sig_end = new Array();

	/* check for simple cases */

	if (source.length < 3) return source; /* one or two points */

	/* more complex case. initialize stack */

	n_source = source.length;
	band_sqr = (kink * 360.0) / (2.0 * Math.PI * 6378137.0); /* Now in degrees */
	band_sqr *= band_sqr;
	n_dest = 0;
	sig_start[0] = 0;
	sig_end[0] = n_source - 1;
	n_stack = 1;

	/* while the stack is not empty  ... */
	while (n_stack > 0) {
		/* ... pop the top-most entries off the stacks */

		start = sig_start[n_stack - 1];
		end = sig_end[n_stack - 1];
		n_stack--;

		if (end - start > 1) {
			/* any intermediate points ? */

			/* ... yes, so find most deviant intermediate point to
                       either side of line joining start & end points */

			x12 = source[end].lng - source[start].lng;
			y12 = source[end].lat - source[start].lat;
			if (Math.abs(x12) > 180.0) x12 = 360.0 - Math.abs(x12);
			x12 *= Math.cos(
				F * (source[end].lat + source[start].lat)
			); /* use avg lat to reduce lng */
			d12 = x12 * x12 + y12 * y12;

			for (i = start + 1, sig = start, max_dev_sqr = -1.0; i < end; i++) {
				x13 = source[i].lng - source[start].lng;
				y13 = source[i].lat - source[start].lat;
				if (Math.abs(x13) > 180.0) x13 = 360.0 - Math.abs(x13);
				x13 *= Math.cos(F * (source[i].lat + source[start].lat));
				d13 = x13 * x13 + y13 * y13;

				x23 = source[i].lng - source[end].lng;
				y23 = source[i].lat - source[end].lat;
				if (Math.abs(x23) > 180.0) x23 = 360.0 - Math.abs(x23);
				x23 *= Math.cos(F * (source[i].lat + source[end].lat));
				d23 = x23 * x23 + y23 * y23;

				if (d13 >= d12 + d23) dev_sqr = d23;
				else if (d23 >= d12 + d13) dev_sqr = d13;
				else dev_sqr = ((x13 * y12 - y13 * x12) * (x13 * y12 - y13 * x12)) / d12; // solve triangle

				if (dev_sqr > max_dev_sqr) {
					sig = i;
					max_dev_sqr = dev_sqr;
				}
			}

			if (max_dev_sqr < band_sqr) {
				/* is there a sig. intermediate point ? */
				/* ... no, so transfer current start point */
				index[n_dest] = start;
				n_dest++;
			} else {
				/* ... yes, so push two sub-sections on stack for further processing */
				n_stack++;
				sig_start[n_stack - 1] = sig;
				sig_end[n_stack - 1] = end;
				n_stack++;
				sig_start[n_stack - 1] = start;
				sig_end[n_stack - 1] = sig;
			}
		} else {
			/* ... no intermediate points, so transfer current start point */
			index[n_dest] = start;
			n_dest++;
		}
	}

	/* transfer last point */
	index[n_dest] = n_source - 1;
	n_dest++;

	/* make return array */
	var r = new Array();
	for (var i: any = 0; i < n_dest; i++) r.push(source[index[i]]);
	return r;
};

export const haversineDistance = (lat1, lng1, lat2, lng2) => {
	const R = 6371;
	const dLat = ((lat2 - lat1) * Math.PI) / 180;
	const dLng = ((lng2 - lng1) * Math.PI) / 180;
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos((lat1 * Math.PI) / 180) *
			Math.cos((lat2 * Math.PI) / 180) *
			Math.sin(dLng / 2) *
			Math.sin(dLng / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	return R * c;
};

// Casas y Más (CYM) es uruguayo: mismos datos que UY (INF-2226).
Object.assign(centers, { CYM: centers.UY });
Object.assign(countryBoundaries, { CYM: countryBoundaries.UY });
